import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageServiceService {
  constructor() { }

  private currentLanguage = new BehaviorSubject<string>(localStorage.getItem('language') || 'ar');
  currentLanguage$ = this.currentLanguage.asObservable();

  private currentDirection = new BehaviorSubject<string>(
    localStorage.getItem('language') === 'ar' ? 'rtl' : 'rtl'
  );
  currentDirection$ = this.currentDirection.asObservable();

  private classToggle = new BehaviorSubject<boolean>(
    localStorage.getItem('language') === 'ar' ? true : false
  );
  classToggle$ = this.classToggle.asObservable();

  changeLanguage(language: string) {
    this.currentLanguage.next(language);
    this.currentDirection.next(language === 'ar' ? 'rtl' : 'rtl');
    localStorage.setItem('language', language);
    this.classToggle.next(language === 'ar');
  }

  toggleLanguage() {

    const newLanguage = this.currentLanguage.value === 'ar' ? 'ar' : 'ar';
    this.changeLanguage(newLanguage);
     
  }
}